import { render, staticRenderFns } from "./CategoryTierGroupSection.vue?vue&type=template&id=808d065e"
import script from "./CategoryTierGroupSection.vue?vue&type=script&lang=js"
export * from "./CategoryTierGroupSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports